export default __webpack_public_path__ + "static/media/Saydaly.3e23f3cb.png";